<template>
  <main>
    <table  class="table datatable insurance-green">
      <thead>
        <tr>
          <th class="text-center" colspan="10">實質接觸前</th>
          <th class="text-center" colspan="2">實質接觸後</th>
        </tr>
        <tr>
          <th>#</th>
          <th
            class="sorting"
            :class="
              order.index == 1
                ? order.asc
                  ? 'sorting_asc'
                  : 'sorting_desc'
                : ''
            "
            @click="columnSorting(1, 'ceapcnm')"
          >
            客戶<br />姓名
          </th>
          <th
            class="sorting"
            :class="
              order.index == 2
                ? order.asc
                  ? 'sorting_asc'
                  : 'sorting_desc'
                : ''
            "
            @click="columnSorting(2, 'idmark')"
          >
            客戶<br />標記
          </th>
          <th
            class="sorting"
            :class="
              order.index == 3
                ? order.asc
                  ? 'sorting_asc'
                  : 'sorting_desc'
                : ''
            "
            @click="columnSorting(3, 'ceplcno')"
          >
            保單號碼
          </th>
          <th
            class="sorting"
            :class="
              order.index == 4
                ? order.asc
                  ? 'sorting_asc'
                  : 'sorting_desc'
                : ''
            "
            @click="columnSorting(4, 'ceclcno_old')"
          >
            原收費<br />代號
          </th>
          <th
            class="sorting"
            :class="
              order.index == 5
                ? order.asc
                  ? 'sorting_asc'
                  : 'sorting_desc'
                : ''
            "
            @click="columnSorting(5, 'clcno')"
          >
            收費<br />代號
          </th>
          <th
            class="sorting"
            :class="
              order.index == 6
                ? order.asc
                  ? 'sorting_asc'
                  : 'sorting_desc'
                : ''
            "
            @click="columnSorting(6, 'cenxpdt')"
          >
            下次<br />應繳日
          </th>
          <th
            class="sorting"
            :class="
              order.index == 7
                ? order.asc
                  ? 'sorting_asc'
                  : 'sorting_desc'
                : ''
            "
            @click="columnSorting(7, 'celpscs_nm')"
          >
            契約<br />效力
          </th>
          <th>保戶<br />通聯</th>
          <th
            class="sorting"
            :class="
              order.index == 9
                ? order.asc
                  ? 'sorting_asc'
                  : 'sorting_desc'
                : ''
            "
            @click="columnSorting(9, 'last_visitday')"
          >
            實質接<br />觸期限
          </th>
          <th
            class="sorting"
            :class="
              order.index == 10
                ? order.asc
                  ? 'sorting_asc'
                  : 'sorting_desc'
                : ''
            "
            @click="columnSorting(10, 'code_nm')"
          >
            撥入<br />原因
          </th>
          <th
            class="sorting"
            :class="
              order.index == 11
                ? order.asc
                  ? 'sorting_asc'
                  : 'sorting_desc'
                : ''
            "
            @click="columnSorting(11, 'fin')"
          >
            已實質<br />接觸
          </th>
        </tr>
      </thead>
      <tbody v-if="tableRow.length > 0">
        <tr v-for="(row, rid) in tableRow" :key="`row-${row.ceplcno}`">
          <td>{{ rid + 1 }}</td>
          <td>{{ row.ceapcnm }}</td>
          <td>
            {{ row.idmark | IDmarkFormat }}
            <!-- 
                              <span v-if="row.idmark && row.idmark.includes('G')">黃金VIP</span>
                              <span v-if="row.idmark && row.idmark.includes('P')">白金VIP</span>
                              <span v-if="row.idmark && row.idmark.includes('D')">鑽石VIP</span>
                              <span v-if="row.idmark && row.idmark.includes('S')">密戶</span>
                              <span v-if="!row.idmark || row.idmark.trim() == '' || row.idmark == '0'">無</span> 
                              -->
          </td>
          <td>{{ row.ceplcno }}</td>
          <td>{{ row.ceclcno_old }}</td>
          <td>{{ row.clcno }}</td>
          <td>{{ row.cenxpdt | dateFormat }}</td>
          <td>{{ row.celpscs_nm }}</td>
          <td>
            <a
              @click="searchConnectInfoDetail(row.ceapcno, row.ceapcnm)"
              class="link text-underline"
              >查詢</a
            >
          </td>
          <td>
            {{ row.last_visitday | dateFormat }}
          </td>
          <td>
            {{ row.code_nm }}
          </td>
          <td class="text-center">
            <span v-if="row.fin == '1'">&#10004;</span>
          </td>
        </tr>
      </tbody>
      <tbody v-else-if="clickSearch && tableRow.length == 0">
        <tr>
          <td class="empty-block bg-white" colspan="12">
            <h1 class="bg-white">無任何資料</h1>
          </td>
        </tr>
      </tbody>
      <tbody v-else>
        <tr>
          <td class="empty-block bg-white" colspan="12">
            <h1 class="bg-white">點擊查詢顯示資料</h1>
          </td>
        </tr>
      </tbody>
    </table>

    <div v-if="tableRow && tableRow.length">
      <ol>
        <li>
          如有其他疑問，請洽總公司業務部業務企劃科，(02)27551399#{{
            contactInfo.contact_tel
          }}
        </li>
      </ol>
    </div>

    <connect-data-modal
      :open="connectModalOpen"
      :detailData="detailData"
      @close="panelClose('connectModalOpen')"
    />
  </main>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { commonMixin } from "@/mixins/common";
import ConnectDataModal from "@/desktop/components/manager/ConnectData";
import { debuglog } from "util";
import { queryBelowEstrangePolicyContactInfo, getContactInfoBySerNo } from "@/service";

export default {
  name: "Tab52Table",
  mixins: [commonMixin],
  components: {
    ConnectDataModal
  },
  props: {
    tableData: {
      type: Array,
      default: () => {
        return [];
      }
    },
    clickSearch: {
      type: Boolean,
      default: () => {
        return false;
      }
    }
  },
  computed: {
    ...mapGetters([])
  },
  data() {
    return {
      tableRow: [],
      detailData: {},
      dataLoading: false,
      selection: {
        clcno: "", // 收費代號
        clcid: "" // 收費人員ID
      },
      connectModalOpen: false,
      order: {
        index: 1,
        asc: true
      },
      contactInfo: []
    };
  },
  watch: {
    tableData: function() {
      this.init();
    }
  },
  methods: {
    ...mapActions(["setPageLock"]),
    searchConnectInfoDetail(ceapcno, ceapcnm) {
      //實質接觸排除整合地址查詢
      this.detailData = {};
      this.dataLoading = true;
      queryBelowEstrangePolicyContactInfo(
        this.$store.state.userInfo.id,
        ceapcno,
        ceapcnm
      ).then(result => {
        this.dataLoading = false;
        if (result.header && result.header.status === "200") {
          this.detailData = result.body.detail;
          this.registerHanlink();
          this.panelOpen("connectModalOpen");
        } else {
          this.detailData = {};
        }
      });
    },
    columnSorting(i, key) {
      if (this.order.index == i) {
        this.order.asc = !this.order.asc;
        if (this.order.asc) {
          this.tableRow = this.tableRow.sort((A, B) => {
            return A[key] > B[key] ? 1 : -1;
          });
        } else {
          this.tableRow = this.tableRow.sort((A, B) => {
            return A[key] <= B[key] ? 1 : -1;
          });
        }
      } else {
        this.order.asc = true;
        this.tableRow = this.tableRow.sort((A, B) => {
          return A[key] > B[key] ? 1 : -1;
        });
      }
      this.order.index = i;

      // for 難字 update
      let cacheList = [...this.tableRow];
      this.tableRow = [];
      setTimeout(() => {
        this.tableRow = cacheList;
        this.registerHanlink();
      }, 200);
    },
    init() {
      this.tableRow = this.tableData.map(ele => {
        return ele;
      });

      // 以流水編號查詢企劃單位連絡方式
      getContactInfoBySerNo(this.$store.state.userInfo.id, '11').then(result => {
        if(result && result.header.status == '200' && result.body){
            this.contactInfo  = result.body.lists[0];
        }
      })
    }
  },
  mounted() {
    this.init();
  }
};
</script>
